import { render, staticRenderFns } from "./WhatIs_components.vue?vue&type=template&id=34be4eb5&scoped=true&"
import script from "./WhatIs_components.vue?vue&type=script&lang=js&"
export * from "./WhatIs_components.vue?vue&type=script&lang=js&"
import style0 from "./WhatIs_components.vue?vue&type=style&index=0&id=34be4eb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34be4eb5",
  null
  
)

export default component.exports